import { Color, MeshStandardMaterial } from '@anov/3d-core'
import { addUpdateTag } from '../decorators'
import type { FinirMaterialInterface } from '.'

type FinirMaterialOption = {
  rimColor?: Color
  rimPower?: number
}

/**
 * 菲尼尔材质
 */
export class FinirMaterial extends MeshStandardMaterial implements FinirMaterialInterface {
  private _rimColor = new Color(0x00FFFF)
  private _rimPower = 0.9

  public get rimColor() {
    return this._rimColor
  }

  @addUpdateTag
  public set rimColor(value: Color) {
    this._rimColor = value
  }

  public get rimPower() {
    return this._rimPower
  }

  @addUpdateTag
  public set rimPower(value: number) {
    this._rimPower = value
  }

  constructor(options?: FinirMaterialOption) {
    super({
      opacity: 0.0,
      transparent: true,
      depthWrite: false,
    })

    const { rimColor = this._rimColor, rimPower = this._rimPower } = options || {}

    this.onBeforeCompile = (shader) => {
      shader.uniforms.rimColor = { value: rimColor }
      shader.uniforms.rimPower = { value: rimPower }
      shader.vertexShader = shader.vertexShader.replace(
        'void main() {',
        [
          'varying vec3 vViewDirection;',
          'void main() {',
          'vec4 worldPosition1 = modelMatrix * vec4(position, 1.0);',
          'vViewDirection = normalize(cameraPosition - worldPosition1.xyz);',
        ].join('\n'),
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        'void main() {',
        [
          'uniform vec3 rimColor;',
          'uniform float rimPower;',
          'varying vec3 vViewDirection;',
          'void main() {',
        ].join('\n'),
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <dithering_fragment>',
        `#include <dithering_fragment>
        vec3 viewDir = normalize(vViewDirection);
        float dotNV = 1.0-saturate( dot( normal, viewDir ) );
        gl_FragColor.rgb += rimPower*dotNV*rimColor;
        vec3 fresnelall =rimPower*dotNV*rimColor;
        gl_FragColor.a +=(fresnelall.r+fresnelall.g+fresnelall.b)/3.;`,
      )
    }
  }

  override clone(): this {
    return new (this.constructor as any)({
      rimColor: this._rimColor,
      rimPower: this._rimPower,
    })
  }
}
